var _excluded = ["text", "id", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import './HelpText.scss';
var propTypes = {
  /** The help text */
  text: string,
  id: string,

  /** Add your own custom class names to the component */
  className: string
};
/** The HelpText is used together with input fields. The purpose is to give the user hints about the input field.
 * @visibleName Help Text
 * */

var HelpText = function HelpText(_ref) {
  var text = _ref.text,
      id = _ref.id,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var componentClassNames = classNames('rds-help-text', className);
  return /*#__PURE__*/React.createElement("small", _extends({
    className: componentClassNames,
    id: id
  }, rest), text);
};

HelpText.propTypes = propTypes;
export default HelpText;